import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class VideoOverlay extends ThemeComponent {
    @Prop overlayImage!: string;
    @Prop heading!: string;
    @Prop buttonText!: string;
    @Prop type!: string;
    @Prop src!: string;
    @Prop contained!: boolean;

    @Ref() play!: HTMLElement;
    @Ref() overlay!: HTMLElement;
    @Ref({required: false}) iframe!: HTMLIFrameElement;
    @Ref({required: false}) video!: HTMLVideoElement;

    init() {
        this.$listen(this.play, 'click', () => this.handlePlayVideo());
    }

    handlePlayVideo() {
        // Hide overlay
        this.overlay.classList.add('video-overlay__overlay--hidden');

        // Handle YouTube
        if (this.type === 'youtube') {
            // Check if a URL param already exists - either create or append
            const symbol = this.iframe.src.indexOf('?') > -1 ? '&' : '?';

            // Modify source to autoplay and start video
            this.iframe.src += symbol + 'autoplay=1';

        // Handle CDN Video
        } else if (this.type === 'cdn') {

            // Set autoplay
            this.video.autoplay = true;

            // Load video
            this.video.load();
        }
    }
}
